export default function StepsSection() {
  return (
    <section className="steps-section" data-testid="steps-section">
      <h2>Check your claim in 3 easy steps</h2>
      <div className="steps-grid">
        <div className="step-card" data-testid="step-card-1">
          <div className="step-icon-ring">
            <span className="step-badge">01</span>
          </div>
          <h3>Find Your Agreements</h3>
          <p>We can find your agreements and manage your claim in a few easy steps.</p>
          <a href="https://sa.yoursolicitor.co.uk/claim" data-ratifi-forward>Find My Agreements</a>
        </div>
        <div className="step-card" data-testid="step-card-2">
          <div className="step-icon-ring">
            <span className="step-badge">02</span>
          </div>
          <h3>Check Your Eligibility</h3>
          <p>Our dedicated legal team will carefully prepare and submit your finance claim, managing everything from start to finish.</p>
        </div>
        <div className="step-card" data-testid="step-card-3">
          <div className="step-icon-ring">
            <span className="step-badge">03</span>
          </div>
          <h3>The Finish Line</h3>
          <p>If you&#39;ve had multiple finance agreements, you could make more than one claim - each potentially worth thousands.</p>
        </div>
      </div>
      <a href="https://sa.yoursolicitor.co.uk/claim" className="btn-primary" data-testid="steps-cta-btn" data-ratifi-forward>
        Check My Claim <span className="arrow">&rarr;</span>
      </a>
      <p className="steps-disclaimer">
        You do not need to use a claims management company or a law firm to make your complaint. You can do this directly. If your complaint is not successful you can refer it to the Financial Ombudsman Service yourself for free.
      </p>
    </section>
  );
}
